<script setup lang="ts">
type TextValue = { value?: string | None }

const props = defineProps<{
  icons: { image?: gen.ImageFragment; title?: TextValue | None; description?: TextValue | None }[] | None
  small?: boolean
}>()

const arr = computed(() => {
  return helpers.arr(props.icons, (i, index) => {
    return {
      key: index,
      title: i.title?.value,
      description: i.description?.value,
      img: i.image,
    }
  })
})
</script>

<template>
  <div :class="$style.col2">
    <div v-for="item in arr" :key="item.key" :class="[$style.outer, small && 'small']" class="_col _ctrY _b5 _hidden _mb-1">
      <div :class="$style.box">
        <BaseImage v-if="item.img" class="_br9 _h40 _w40 _noflex" :class="$style.noflex" :img="item.img" sizes="50px" ratio="square" no-color />

        <span :class="$style.txt">
          <div class="_ls-xs _lh11 _fs09 _pt04 _pb04">{{ item.title }}</div>
          <div v-if="item.description" class="_italic">{{ item.description }}</div>
        </span>
      </div>
    </div>
  </div>
</template>

<style module>
.col2 {
  composes: global(_hidden);
  composes: global(_br9);
  composes: global(_grid);
  composes: global(_pb02);
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.outer:first-child,
.outer:nth-child(2) {
  border-top-left-radius: 9px;
  border-top-right-radius: 9px;
}
.outer:nth-last-child(2),
.outer:last-child {
  border-bottom-right-radius: 9px;
  border-bottom-left-radius: 9px;
}
.outer:nth-child(even) {
  margin-left: -1px;
}

.box {
  composes: global(_row);
  composes: global(m_ctrX);
  composes: global(_ctrY);

  composes: global(d_pt04);
  composes: global(m_pt1);

  composes: global(d_pb04);
  composes: global(m_pb1);

  composes: global(m_pl04);
  composes: global(m_pr04);

  composes: global(d_pr1);
  composes: global(d_pl1);

  composes: global(d_gap2);
  composes: global(m_gap04);

  composes: global(_relative);
  composes: global(_hm80);
  composes: global(_w100p);
  composes: global(m_txt_ctr);

  composes: global(_c1);
  composes: global(_start);
}
:global(.m) .box {
  flex-flow: column nowrap;
}
.txt {
  composes: global(_row);
  composes: global(m_col);
  composes: global(_inline);
  composes: global(_wrap);
  composes: global(_ctrY);
  composes: global(d_pr2);
  composes: global(m_ctrX);

  composes: global(_spaced);

  gap: 0px 14px;
  flex-grow: 9999;
  flex-shrink: 1;
  transition: padding 100ms var(--tran2);
}

.outer:global(.small) > .box {
  min-height: 64px;
}
</style>
